import dashboard from "./dashboard";
// import masksList from "./masks-list";
import configurations from "./configurations";
// import userList from "./user-list";
import reports from "./reports";
import adminList from "./admin-list";
import campaigns from "./campaign";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, campaigns, adminList, reports, configurations],
};

export default menuItems;
